import React from 'react';
import { Root } from 'react-dom/client';

import { createRoot } from 'react-dom/client';

import { PopupWidget as DeckGLPopupWidget } from '@deck.gl/widgets';
import { Popover } from './Popover';
import { UserContent } from './UserContent';
import { IconButton } from './IconButton';

export class PopupWidget extends DeckGLPopupWidget {
  root: Root | undefined;
  private prevKey = '';
  private anchorEl: HTMLElement | null = null;

  onRemove() {
    if (this.root) {
      this.root.unmount();
    }

    this.root = undefined;
    this.prevKey = '';
  }

  onRenderHTML(rootElement: HTMLElement): void {
    if (!this.root) {
      this.root = createRoot(rootElement as HTMLElement);
    }

    if (!this.viewport) {
      this.root.unmount();
      this.root = undefined;
      this.prevKey = '';
      return;
    }

    const { content, style, className, placement, arrow, offset } = this.props;
  
    const key = `${className}|${placement}|${offset}|${arrow}|${
      typeof content === 'string' ? content : JSON.stringify(content)
    }`;


    if (key !== this.prevKey) {
      this.prevKey = key;

      this.root.render(
        <div>
          {/* {marker && (
            <div className="deck-widget-popup-marker" style={{left: x, top: y}}>
              <UserContent {...marker} onClick={() => this._setIsOpen(true)} />
            </div>
          )} */}
          {this.isOpen && (
            <Popover
              placement={this.props.placement}
              arrow={this.props.arrow}
              arrowColor="var(--menu-background, #fff)"
              offset={this.props.offset}
              anchorPopoverRef={(el) => {
                this.anchorEl = el;
              }}
            >
              <div
                className="deck-widget-popover-arrow"
                style={{position: 'absolute'}}
              />
              <div
                className={`deck-widget-popup-content ${this.props.className}`}
                style={style as React.CSSProperties}
              >
                {this.props.closeButton && (
                  <div
                    className="deck-widget-popup-controls"
                    style={{width: '100%', display: 'flex', justifyContent: 'end'}}
                  >
                    <IconButton
                      className="deck-widget-popup-close-button"
                      onClick={() => this._setIsOpen(false)}
                    />
                  </div>
                )}
                <UserContent {...(typeof content === 'string' ? {text: content} : content)} />
              </div>
            </Popover>
          )}
        </div>
      );
    }

    const [x, y] = this.viewport.project(this.props.position);
    if (this.anchorEl) {
      this.anchorEl.style.left = `${x}px`;
      this.anchorEl.style.top = `${y}px`;
    }
  }
}